import { css } from '@linaria/atomic'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'
import shape from '../styles/shape'
import { APP_FONT } from '../theme'

export const BOX_SIZE = 18
export const BOX_SIZE_SMALL = 15
export const WRAPPER_PADDING = 12

export const controlRootStyles = css`
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    cursor: pointer;
    font-family: ${APP_FONT};
    margin-left: -${WRAPPER_PADDING}px;
    -webkit-tap-highlight-color: transparent;

    & .control-wrapper {
        position: relative;
        display: inline-flex;
        flex: 0 0 auto;
        padding-top: ${WRAPPER_PADDING}px;
        padding-bottom: ${WRAPPER_PADDING}px;
        padding-left: ${WRAPPER_PADDING}px;
        padding-right: ${WRAPPER_PADDING}px;
        border-radius: 50%;
        line-height: 0;
        overflow: hidden;
    }

    & .control-ripple {
        position: absolute;
        opacity: 0.5;
        background-color: ${palette.checkboxOptionColor};
        transform: translate(-50%, -50%);
        pointer-events: none;
        border-radius: 50%;
        aspect-ratio: 1;
        -webkit-tap-highlight-color: transparent;
    }

    & .control-input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        margin: 0;
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 0;
        padding-right: 0;
        opacity: 0;
        cursor: inherit;
        z-index: 1;
    }

    & .control-box {
        position: relative;
        box-sizing: border-box;
        display: block;
        width: ${BOX_SIZE}px;
        height: ${BOX_SIZE}px;
        border-width: 2px;
        border-style: solid;
        border-color: currentColor;
        color: ${palette.checkboxOptionColor};
        transition: background-color 120ms ease-out;
    }

    & .control-icon {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        fill: currentColor;
        pointer-events: none;
        color: ${palette.checkboxOptionColor};
    }

    & .control-icon-checked {
        opacity: 0;
        transform: scale(0.4);
        transform-origin: center;
        transition:
            opacity 120ms ease-out,
            transform 120ms ease-out;
    }

    & .control-input:checked + .control-box .control-icon-checked {
        opacity: 1;
        transform: scale(1);
    }

    & .control-text {
        font-size: 1em;
        font-weight: 500;
    }

    &:hover .control-wrapper {
        background-color: ${palette.radioHover};
    }

    & .control-input:focus-visible + .control-box {
        outline: 2px solid ${palette.checkboxOptionColor};
        outline-offset: 2px;
    }
`

export const controlSmallStyles = css`
    & .control-box {
        width: ${BOX_SIZE_SMALL}px;
        height: ${BOX_SIZE_SMALL}px;
    }
`

export const controlDenseStyles = css`
    margin-left: 0;

    & .control-wrapper {
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 0;
        padding-right: 0;
        border-radius: ${shape.borderRadius}px;
    }
`

export const controlDisabledStyles = css`
    cursor: default;

    & .control-box {
        color: ${palette.inactiveGrey};
    }

    &:hover .control-wrapper {
        background-color: transparent;
    }
`

export const controlFullWidthLabelStyles = css`
    width: 100%;

    & .control-text {
        width: 100%;
    }
`

export const controlLabelStartStyles = css`
    flex-direction: row-reverse;
    margin-left: 0;
    margin-right: -${WRAPPER_PADDING}px;
`

export const controlGroupStyles = css`
    display: flex;
    flex-direction: column;
    font: inherit;
    padding-bottom: ${getThemeSpacing(1)};
`

export const controlGroupRowStyles = css`
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${getThemeSpacing(2)};
`

export const denseControlGroupStyles = css`
    padding-bottom: 0px;
`
